// React
import React from "react";
// React
// CSS
import styles from "./ContactCard.module.css";
import { I_ContactItem } from "../../../../Models/interfaces";
// CSS

type ContactCardProps = {
  data: I_ContactItem;
};

const ContactCard: React.FunctionComponent<ContactCardProps> = ({
  data: {
    order,
    social: { icon_path, id, name, numeric },
    title,
    url,
    value,
    color,
  },
}) => {
  return (
    <a
      href={numeric ? `tel:${value}` : url}
      className={`${styles.contactCardItem} w-full flex flex-row-reverse items-center justify-between mt-6`}
    >
      <div
        className={`${styles.right} flex flex-row-reverse items-center justify-start`}
      >
        <img
          src={icon_path.replace(/(http[^\s])/i, "https:").replace("::", ":")}
          alt=""
          className="w-4 h-4 "
        />
        <p className="mr-4" style={{ color }}>
          {title}
        </p>
      </div>
      <p className={`${styles.left}`} style={{ color }}>
        {value}
      </p>
    </a>
  );
};

export default ContactCard;
